module.exports = __webpack_public_path__ + "788f3e2af54fdedc56e32d20777fcf5b.svg";